"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationJsonMock = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const ManagedConfigurationType_1 = require("./ManagedConfigurationType");
const echain_product_models_1 = require("@igus/echain-product-models");
exports.configurationJsonMock = {
    DomainVersion: '0.0.1',
    ManagedConfigurationType: ManagedConfigurationType_1.ManagedConfigurationType.IQuote,
    ConfigurationStartedWith: 'kette',
    IaArrangement: echain_shared_igus_fundamentals_1.IaArrangement.single,
    IsAlienConfiguration: false,
    IAAuthorName: 'sdfsd',
    IARemark: 'bemerkung',
    IACompanyName: 'sdfsd',
    IgusGUIds: [],
    IsIgnoreSafetyDistance: false,
    Bezeichnung: { 'de-DE': 'Ihr konfiguriertes igus e-ketten System' },
    Leitungen: [
        {
            ArticleType: echain_product_models_1.ArticleType.leitung,
            EntityId: '1508923396598_22991',
            Id: 33036,
            ArtNr: { DE: 'CF5.07.03', US: 'CF5-07-03' },
            ArtNrExists: true,
            ArtNrGenerated: 'CF5.07.03',
            Bezeichnung: {
                'de-DE': 'chainflex® CF5 Steuerleitung PVC',
                'hu-HU': 'chainflex® CF5 PVC vezérlőkábel',
                'en-US': 'chainflex® CF5 control cable PVC',
                'zh-TW': 'chainflex® CF5 PVC控制電纜',
                'ko-KR': 'Chainflex® CF5 컨트롤 케이블 PVC',
                'es-ES': 'Cable de mando chainflex® CF5.UL PVC',
                'zh-CN': 'chainflex® CF5 PVC控制电缆',
                'it-IT': 'chainflex® CF5 cavo di comando PVC',
                'pl-PL': 'Przewód sterujący chainflex® CF5 z PCV',
                'nl-NL': 'chainflex® CF5 stuurstroomkabel PVC',
                'pt-PT': 'chainflex® CF5 - Cabo de Comando em PVC',
                'sv-SE': 'chainflex® CF5 PVC-styrkabel',
                'da-DK': 'PVC-kontrolkabel chainflex® CF5',
                'cs-CZ': 'Ovládací kabel chainflex® CF5 z PVC',
                'fr-FR': 'Câble de commandes chainflex® CF5 PVC',
                'en-GB': 'chainflex® CF5 control cable PVC',
                'ja-JP': 'チェーンフレックスCF5 制御ケーブル PVC外被',
            },
            Beschriftung: 'Keine',
            BeschriftungFixedEnd: 'Keine',
            Aussendurchmesser: { Unit: 'mm', Value: 6.5 },
            Kupferzahl: { Unit: 'kg_km', Value: 24 },
            LaengeUeberstandLock: 'festpunktAndMitnehmer',
            Leitungsaufbau: { 'de-DE': '3G0,75' },
            Leitungslaenge: { Unit: 'mm', Value: 2214 },
            GewichtKgProKm: { Unit: 'kg_km', Value: 56 },
            BiegeradiusMin: { Unit: 'mm', Value: 44.199999999999996 },
            FesteLaenge: false,
            UeberstandFestpunkt: { Unit: 'mm', Value: 25 },
            UeberstandMitnehmer: { Unit: 'mm', Value: 25 },
            RAL_Nummer: '6005',
            Categories: [echain_shared_articles_1.LeitungCategory.ControlCables],
            MainCategory: echain_shared_articles_1.LeitungCategory.ControlCables,
            ArticleSpecs: [echain_shared_articles_1.ArticleSpecs.Chainflex],
            LocalTransform: [1, 0, 0, 1, 21.586790084838867, 11.512377738952637],
            IAIndex: '1',
            Aderzahl: '0',
            AkeneoSku: '',
            AuhiGleitend: false,
            AuhiTemperaturMax: {
                Unit: 'K',
                Value: 111,
            },
            AuhiTemperaturMin: {
                Unit: 'K',
                Value: 11,
            },
            DESINA: false,
            DiscontinuedModel: false,
            DNV_GL: false,
            DataSource: 'mix',
            EAC: false,
            EchainId: 'mocked-id!',
            Flammwidrig: false,
            FreigabeECF: false,
            FreigabeEIC: false,
            FreigabeEIQ: false,
            FreigabeEKE: false,
            FreitragenderBetriebErlaubt: false,
            Gesamtschirm: false,
            HaengenderBetriebErlaubt: false,
            Halogenfrei: false,
            Kuehlmittelbestaendig: false,
            MUDBestaendig: false,
            Mantelwerkstoff: echain_product_models_1.Mantelwerkstoff.PUR,
            Oelbestaendigkeit: echain_product_models_1.OelBestaendigkeit.Class1,
            Querschnitt: {},
            Reinraum: false,
            Schirmung: false,
            Torsionsfaehig: false,
            TwistedPair: false,
            UL_CSA: false,
            UVBestaendigkeit: echain_product_models_1.UvBestaendigkeit.Gering,
            Ungeschirmt: false,
            HatStecker: false,
        },
    ],
    AEs: [
        {
            ArticleType: echain_product_models_1.ArticleType.ae,
            EntityId: '1508923396601_22997',
            Id: 33891159500,
            ArtNr: { DE: '3150.1PZ.A3' },
            ArtNrExists: true,
            ArtNrGenerated: '3150.1PZ.A3.X46',
            Bezeichnung: {
                'de-DE': 'Kunststoff, starr, ohne Kamm',
                'en-GB': 'Plastic, locking, without tiewrap plate',
            },
            KetteRef: [
                3439, 3440, 3441, 3442, 3443, 3444, 3445, 3749, 3750, 3751, 3752, 3753, 3754, 3755, 4814, 4815, 4816, 4817,
                4818, 4819, 4820, 4906, 4935, 4936, 4937, 4938, 5017, 5018, 5019, 5020, 5021, 5022, 5023, 46456, 46462, 46463,
                46464, 46465, 59527, 59537, 68064, 68074,
            ],
            Laenge: { Unit: 'mm', Value: 60 },
            Montiert: true,
            Befestigungsvariante: 'A3',
            Gewicht: { Unit: 'kg', Value: 0.100639999389648 },
            Color: '0',
            Material: '0',
            AufbauId: 1,
            FestpunktGerade: false,
            FestpunktUngerade: false,
            KomplettsatzGerade: false,
            KomplettsatzUngerade: false,
            MitnehmerGerade: true,
            MitnehmerUngerade: true,
            ZugentlastungTyp: 'Ohne_Kamm',
            Zweiteilig: false,
            Application: 1,
            Festpunkt: false,
            GliedAnzahlAbhaengig: 0,
            Komplettsatz: false,
            Mitnehmer: true,
            ZubehoerRef: [],
        },
    ],
    IAs: [
        {
            ArticleType: echain_product_models_1.ArticleType.ia,
            EntityId: '1508923415937_49803',
            IABodenH: { Unit: 'mm', Value: 3.4 },
            IAHKB: { Unit: 'mm', Value: 0 },
            IAHKBOT: { Unit: 'mm', Value: 0 },
            IAHKDist: { Unit: 'mm', Value: 0 },
            IAHKH: { Unit: 'mm', Value: 0 },
            IAHKHeight: { Unit: 'mm', Value: 0 },
            IAHKOLB: { Unit: 'mm', Value: 0 },
            IAHKOLOB: { Unit: 'mm', Value: 0 },
            IAHKOLOH: { Unit: 'mm', Value: 0 },
            IAHKOLUB: { Unit: 'mm', Value: 0 },
            IAHKOLUH: { Unit: 'mm', Value: 0 },
            IAHKOLUH_Rounded: false,
            IAHKORB: { Unit: 'mm', Value: 0 },
            IAHKOROB: { Unit: 'mm', Value: 0 },
            IAHKORUB: { Unit: 'mm', Value: 0 },
            IAHKRep: 0,
            IAHKULB: { Unit: 'mm', Value: 0 },
            IAHKULOB: { Unit: 'mm', Value: 0 },
            IAHKULOH: { Unit: 'mm', Value: 0 },
            IAHKULOH_Rounded: false,
            IAHKULUB: { Unit: 'mm', Value: 0 },
            IAHKULUH: { Unit: 'mm', Value: 0 },
            IAHKURB: { Unit: 'mm', Value: 0 },
            IAHKUROB: { Unit: 'mm', Value: 0 },
            IAHKURUB: { Unit: 'mm', Value: 0 },
            IAKisteHO: { Unit: 'mm', Value: 0 },
            IAKisteHU: { Unit: 'mm', Value: 0 },
            IAUebermass: { Unit: 'mm', Value: 0 },
            IAwmm: { Unit: 'mm', Value: 150 },
            LocalTransform: [1, 0, 0, 1, 0, 0],
            Id: 3573,
            ArtNr: { DE: '321.150', US: '321-150' },
            ArtNrExists: true,
            ArtNrGenerated: '321.150',
            Bezeichnung: {
                'de-DE': 'Einsteckboden, montiert',
                'hu-HU': 'Betett polc, szerelt',
                'en-US': 'Full-width shelf, assembled ',
                'zh-TW': '全寬水準分隔片，裝配件',
                'ko-KR': '전폭 가로분리대, 조립',
                'es-ES': 'Base insertable, montada',
                'zh-CN': '全宽水平分隔片，装配件',
                'it-IT': 'Separatore orizzontale a piena larghezza, montato',
                'pl-PL': 'Półka o pełnej szerokości, zmontowana',
                'nl-NL': 'Tussenschot met maximale breedte, gemonteerd',
                'pt-PT': 'Travessa longitudinal, montada',
                'sv-SE': 'Hyllplan, monterat',
                'da-DK': 'Hylde i fuld bredde, samlet',
                'cs-CZ': 'Příčka v plné šíři, sestavená',
                'fr-FR': 'Fond amovible, monté',
                'en-GB': 'Full-width shelf, assembled',
                'ja-JP': '貫通型棚板、エナジーチェーンに組付け',
            },
            Artikeltyp: 2400,
            BestTyp: 300,
            KetteSerieRef: [
                { Id: 3402, Kuerzel: '340', Artikeltyp: 2400 },
                { Id: 3712, Kuerzel: '350', Artikeltyp: 2400 },
                { Id: 4777, Kuerzel: '3400', Artikeltyp: 2400 },
                { Id: 4891, Kuerzel: '3450', Artikeltyp: 2400 },
                { Id: 4980, Kuerzel: '3500', Artikeltyp: 2400 },
                { Id: 5428, Kuerzel: '167', Artikeltyp: 2400 },
                { Id: 5563, Kuerzel: '168', Artikeltyp: 2400 },
                { Id: 5875, Kuerzel: '68', Artikeltyp: 2400 },
                { Id: 26666, Kuerzel: 'E6.52', Artikeltyp: 2400 },
                { Id: 26800, Kuerzel: 'E6.62', Artikeltyp: 2400 },
                { Id: 38489, Kuerzel: '3480', Artikeltyp: 2400 },
            ],
            KetteRef: [
                3439, 3440, 3441, 3442, 3443, 3444, 3445, 3749, 3750, 3751, 3752, 3753, 3754, 3755, 4814, 4815, 4816, 4817,
                4818, 4819, 4820, 4906, 4935, 4936, 4937, 4938, 5017, 5018, 5019, 5020, 5021, 5022, 5023, 5470, 5471, 5472,
                5473, 5474, 5475, 5476, 5477, 5605, 5606, 5607, 5608, 5609, 5610, 5611, 5612, 5917, 5918, 5919, 5920, 5921,
                5922, 5923, 5924, 26703, 26704, 26705, 26706, 26707, 26856, 26857, 26858, 26859, 26860, 26861, 46456, 46462,
                46463, 46464, 46465, 59527, 59537, 68064, 68074,
            ],
            Breite: { Unit: 'mm', Value: 150 },
            Montiert: true,
            Color: '0',
            PerNthKettenglied: 2,
            StartingAtNthKettenglied: 1,
        },
    ],
    Zugentlastungen: [
        {
            ArticleType: echain_product_models_1.ArticleType.zugentlastung,
            EntityId: '1508923396603_23002',
            Id: 350469469200,
            ArtNr: { DE: 'CF.92.52.XX.E' },
            ArtNrExists: false,
            ArtNrGenerated: 'CF.92.52..E',
            Bezeichnung: {
                'fr-FR': 'Rail en C, en inox, pour une force de retenue élevée, montage devant la chaîne port-câbles',
                'de-DE': 'C-Profil, Edelstahl, für erhöhte Haltekraft, Montage vor der e-kette',
                'en-GB': 'C-profile, stainless steel, for greater holding strength, mounting before the e-chain',
            },
            Laengeneingabe: true,
            Breite: { Unit: 'mm', Value: 1 },
            Dmin: { Unit: 'mm', Value: 0 },
            Dmax: { Unit: 'mm', Value: 0 },
            Montage: {
                '*': [
                    '1400',
                    '1500',
                    '2400',
                    '2500',
                    '2450',
                    '2480',
                    '2600',
                    '2700',
                    '2650',
                    '2680',
                    '3400',
                    '3500',
                    '3450',
                    '3480',
                    'R117',
                    'R118',
                    'R157',
                    'R158',
                    'R167',
                    'R168',
                    'R48',
                    'R58.New',
                    'R68.New',
                    'E4.21',
                    'E4.28',
                    'R4.28',
                    'E4.32',
                    'H4.32',
                    'R4.32',
                    'E4.42',
                    'H4.42',
                    'R4.42',
                    'E4.56',
                    'H4.56',
                    'R4.56',
                    'E4.80',
                    'H4.80',
                    'R4.80',
                    'E4.112',
                    'E4.162',
                    '800',
                    'E4.31L',
                    'R4.31L',
                    'E4.38L',
                    'R4.38L',
                    'E4.48L',
                    'R4.48L',
                    'E4.64L',
                    '14040',
                    '14140',
                    'R18840',
                    '14240',
                    '14340',
                    '14550',
                    '14650',
                    'R19050',
                    '15050',
                    '15150',
                    'R19850',
                    '15250',
                    '15350',
                    '1640',
                    'R1608',
                    'E61.29',
                    'EF61.29',
                    'E61.35',
                    'E61.40',
                    'E61.52',
                    'E61.62',
                    'E61.80',
                    'E6.29',
                    'R6.29',
                    'E6.35',
                    'E61.40',
                    'E61.52',
                    'E61.62',
                    'E61.80',
                    'E6.40',
                    'E6.52',
                    'R6.52',
                    'E6.62',
                    'E6.80L',
                    'E6.80',
                ],
            },
            Montagetyp: [],
            IsSet: false,
        },
    ],
    Verpackungen: [
        {
            ArticleType: echain_product_models_1.ArticleType.verpackung,
            EntityId: '1508954445089_947461',
            Id: 1805874262,
            ArtNr: { DE: 'MAT0178542' },
            ArtNrExists: true,
            ArtNrGenerated: 'MAT0178542',
            Bezeichnung: { 'de-DE': 'Trommel', 'en-GB': 'Drum', 'en-US': 'Drum' },
            Preis: { Countries: { DE: { EUR: 403.95 } } },
            Typ: 'trommel',
            Verpackungsmittel: 'Trommel',
            Kerndurchmesser: { Unit: 'mm', Value: 455 },
            Innenbreite: { Unit: 'mm', Value: 700 },
            Flanschdurchmesser: { Unit: 'mm', Value: 1800 },
            Flanschstaerke: { Unit: 'mm', Value: 24 },
            TrommelbelastungMax: { Unit: 'kg', Value: 500 },
            Trommelkern: 'festpunkt',
            Waermebehandelt: true,
        },
        {
            ArticleType: echain_product_models_1.ArticleType.verpackung,
            EntityId: '1509014752549_3194906',
            ArtNrExists: false,
            ArtNrGenerated: 'CUSTOMTEST',
            Bezeichnung: { 'de-DE': 'custom bezeichnung' },
            Preis: { Countries: { DE: { EUR: 12 } } },
            Typ: 'karton',
            Verpackungsmittel: 'Karton',
            Laenge: { Unit: 'mm', Value: 7 },
            Breite: { Unit: 'mm', Value: 3 },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.verpackung,
            EntityId: '1508954445089_947457',
            Id: 416230610,
            ArtNr: { DE: 'MAT0010092' },
            ArtNrExists: true,
            ArtNrGenerated: 'MAT0010092',
            Bezeichnung: { 'de-DE': 'Palette', 'en-GB': 'Pallet', 'en-US': 'Pallet' },
            Preis: { Countries: { DE: { EUR: 15.21 } } },
            Typ: 'palette',
            Verpackungsmittel: 'Palette',
            Laenge: { Unit: 'mm', Value: 1050 },
            Breite: { Unit: 'mm', Value: 800 },
        },
    ],
    Kette: {
        ArticleType: echain_product_models_1.ArticleType.kette,
        KetteSerieType: echain_shared_articles_1.KetteSerieType.default,
        LangerWeg: true,
        Einspeisung: 1,
        Versatz: { Unit: 'mm', Value: 0 },
        MinDistKlemmO: { Unit: 'mm', Value: 0 },
        MinDistKlemmU: { Unit: 'mm', Value: 0 },
        MinDistO: { Unit: 'mm', Value: 0 },
        MinDistU: { Unit: 'mm', Value: 0 },
        RastPosDist: { Unit: 'mm', Value: 1 },
        RastPosLeft: { Unit: 'mm', Value: 0 },
        MinBauraumGleitendRinneRefs: [],
        Id: 4817,
        ArtNr: { DE: '3400.150.150.0', US: '3400-150-150-0' },
        ArtNrExists: true,
        ArtNrGenerated: '3400.150.150.0',
        Bezeichnung: {
            'de-DE': 'e-kette® Serie 3400',
            'hu-HU': 'E-Chains® 3400 Széria',
            'en-US': 'Energy chain® Series 3400',
            'zh-TW': '3400系列拖鏈',
            'ko-KR': 'E-Chain® 3400 시리즈',
            'es-ES': 'E-Chains® Serie 3400',
            'zh-CN': '3400系列拖链',
            'it-IT': 'Catena portacavi serie 3400',
            'pl-PL': 'E-Chains® Seria 3400',
            'pt-PT': 'Calhas articuladas da Série 3400',
            'nl-NL': 'Kabelrupsen Series 3400',
            'sv-SE': 'E-kedja serie 3400',
            'da-DK': 'E-Kæde -serie 3400',
            'cs-CZ': 'e-chain® série 3400',
            'fr-FR': 'Chaîne Série 3400',
            'en-GB': 'e-chain® Series 3400',
            'ja-JP': 'エナジーチェーン 3400型',
        },
        ReferenceKetteJson: {
            SerieRef: { Kuerzel: '3400', Id: 4777 },
            FreitragenderBetriebErlaubt: true,
            K2: { Value: 1005, Unit: 'mm' },
            GewichtKgProM: { Value: 2.17, Unit: 'kg_m' },
            NoSeparaterFootTop: true,
            Aussenbreite: { Value: 170, Unit: 'mm' },
            Teilung: { Value: 67, Unit: 'mm' },
            Halbstegig: false,
            ArtSerieBreite: '3400.150',
            IndexBreite: '150',
            LeitungDiameterMax: { Value: 42, Unit: 'mm' },
            StandardTrennstegArtNr: '45.1.1',
            Innenbreite: { Value: 150, Unit: 'mm' },
            IndexBiegeradius: '150',
            K: { Value: 610, Unit: 'mm' },
            Aussenhoehe: { Value: 64, Unit: 'mm' },
            Biegeradius: { Value: 150, Unit: 'mm' },
            ArtNr: { DE: '3400.150.150.0', US: '3400-150-150-0' },
            UngeradeAnzahlGlieder: false,
            Bauform: 'Kette',
            GleitenderBetriebErlaubt: true,
            Id: 4817,
            Innenhoehe: { Value: 45, Unit: 'mm' },
            VersatzFestpunktErlaubt: true,
            Bezeichnung: {
                'de-DE': 'e-kette® Serie 3400',
                'hu-HU': 'E-Chains® 3400 Széria',
                'en-US': 'Energy chain® Series 3400',
                'zh-TW': '3400系列拖鏈',
                'ko-KR': 'E-Chain® 3400 시리즈',
                'es-ES': 'E-Chains® Serie 3400',
                'zh-CN': '3400系列拖链',
                'it-IT': 'Catena portacavi serie 3400',
                'pl-PL': 'E-Chains® Seria 3400',
                'pt-PT': 'Calhas articuladas da Série 3400',
                'nl-NL': 'Kabelrupsen Series 3400',
                'sv-SE': 'E-kedja serie 3400',
                'da-DK': 'E-Kæde -serie 3400',
                'cs-CZ': 'e-chain® série 3400',
                'fr-FR': 'Chaîne Série 3400',
                'en-GB': 'e-chain® Series 3400',
                'ja-JP': 'エナジーチェーン 3400型',
            },
        },
        SerieRef: { Id: 4777, Kuerzel: '3400' },
        IndexBreite: '150',
        IndexBiegeradius: '150',
        ArtSerieBreite: '3400.150',
        GleitenderBetriebErlaubt: true,
        UngeradeAnzahlGlieder: false,
        VersatzFestpunktErlaubt: true,
        Teilung: { Unit: 'mm', Value: 67 },
        Aussenhoehe: { Unit: 'mm', Value: 64 },
        Innenhoehe: { Unit: 'mm', Value: 45 },
        Biegeradius: { Unit: 'mm', Value: 150 },
        Aussenbreite: { Unit: 'mm', Value: 170 },
        Innenbreite: { Unit: 'mm', Value: 150 },
        K: { Unit: 'mm', Value: 610 },
        K2: { Unit: 'mm', Value: 1005 },
        GewichtKgProM: { Unit: 'kg_m', Value: 2.17 },
        LeitungDiameterMax: { Unit: 'mm', Value: 42 },
        Halbstegig: true,
        Bauform: 'Kette',
        Color: '0',
        EffektiveLaenge: { Unit: 'mm', Value: 2010 },
        EffektiveLaengeWithAEs: { Unit: 'mm', Value: 2164 },
        Laenge: { Unit: 'mm', Value: 2005 },
        NumGlieder: 30,
        Verfahrweg: { Unit: 'mm', Value: 2000 },
        NoSeparaterFootTop: true,
        StandardTrennstegArtNr: '45.1.1',
        StaticIAArtikelRef: [],
        IsMontageMitnehmer: false,
        LengthCalcInitializedBy: echain_shared_articles_1.KetteLengthCalcInitializedBy.verfahrweg,
        EntityId: '1508923396600_22996',
        RinneRef: [],
        MontagesetRef: [],
        RinnenvarianteRef: [],
        BelastungFLG: [],
        BelastungFLB: [],
    },
    Konfektionierungen: [
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_237',
            Typ: 'leitungEinlegenMeterFactorDefault',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 1.52 },
                    AT: { EUR: 1.52 },
                    BE: { EUR: 1.52 },
                    FR: { EUR: 1.216 },
                    NL: { EUR: 1.52 },
                },
            },
            Id: 447436798,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 1.52 },
                    DE: { EUR: 1.52 },
                    AT: { EUR: 1.52 },
                    BE: { EUR: 1.52 },
                    FR: { EUR: 1.52 },
                    NL: { EUR: 1.52 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_238',
            Typ: 'schliessenOeffnungsstegFactorRohr',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 0.285 },
                    AT: { EUR: 0.285 },
                    BE: { EUR: 0.285 },
                    FR: { EUR: 0.228 },
                    NL: { EUR: 0.285 },
                },
            },
            Id: 555326273,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 0.285 },
                    DE: { EUR: 0.285 },
                    AT: { EUR: 0.285 },
                    BE: { EUR: 0.285 },
                    FR: { EUR: 0.285 },
                    NL: { EUR: 0.285 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_239',
            Typ: 'verpackungPaletteOver900',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 18 },
                    AT: { EUR: 18 },
                    BE: { EUR: 18 },
                    FR: { EUR: 14.4 },
                    NL: { EUR: 18 },
                },
            },
            Id: 558121984,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 18 },
                    DE: { EUR: 18 },
                    AT: { EUR: 18 },
                    BE: { EUR: 18 },
                    FR: { EUR: 18 },
                    NL: { EUR: 18 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_240',
            Typ: 'verpackungMaterialPalette',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 6.25 },
                    AT: { EUR: 6.25 },
                    BE: { EUR: 6.25 },
                    FR: { EUR: 5 },
                    NL: { EUR: 6.25 },
                },
            },
            Id: 588392988,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 6.25 },
                    DE: { EUR: 6.25 },
                    AT: { EUR: 6.25 },
                    BE: { EUR: 6.25 },
                    FR: { EUR: 6.25 },
                    NL: { EUR: 6.25 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_241',
            Typ: 'paletteRatePerMeter',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 3.94 },
                    AT: { EUR: 3.94 },
                    BE: { EUR: 3.94 },
                    FR: { EUR: 3.152 },
                    NL: { EUR: 3.94 },
                },
            },
            Id: 1069714965,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 3.94 },
                    DE: { EUR: 3.94 },
                    AT: { EUR: 3.94 },
                    BE: { EUR: 3.94 },
                    FR: { EUR: 3.94 },
                    NL: { EUR: 3.94 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_242',
            Typ: 'auftrommelnTransportgestellAnschrauben',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 17.25 },
                    AT: { EUR: 17.25 },
                    BE: { EUR: 17.25 },
                    FR: { EUR: 13.8 },
                    NL: { EUR: 17.25 },
                },
            },
            Id: 1298838445,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 17.25 },
                    DE: { EUR: 17.25 },
                    AT: { EUR: 17.25 },
                    BE: { EUR: 17.25 },
                    FR: { EUR: 17.25 },
                    NL: { EUR: 17.25 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_243',
            Typ: 'leitungEinlegenMeterFactorChainClosed',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 2.337 },
                    AT: { EUR: 2.337 },
                    BE: { EUR: 2.337 },
                    FR: { EUR: 1.8696 },
                    NL: { EUR: 2.337 },
                },
            },
            Id: 1372216001,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 2.337 },
                    DE: { EUR: 2.337 },
                    AT: { EUR: 2.337 },
                    BE: { EUR: 2.337 },
                    FR: { EUR: 2.337 },
                    NL: { EUR: 2.337 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_244',
            Typ: 'verpackungPaletteUnder901',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 12 },
                    AT: { EUR: 12 },
                    BE: { EUR: 12 },
                    FR: { EUR: 9.6 },
                    NL: { EUR: 12 },
                },
            },
            Id: 1626286141,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 12 },
                    DE: { EUR: 12 },
                    AT: { EUR: 12 },
                    BE: { EUR: 12 },
                    FR: { EUR: 12 },
                    NL: { EUR: 12 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_245',
            Typ: 'BeschriftungLeitungFactorMoreThan_3',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 3.6 },
                    AT: { EUR: 3.6 },
                    BE: { EUR: 3.6 },
                    FR: { EUR: 2.88 },
                    NL: { EUR: 3.6 },
                },
            },
            Id: 2189744915,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 3.6 },
                    DE: { EUR: 3.6 },
                    AT: { EUR: 3.6 },
                    BE: { EUR: 3.6 },
                    FR: { EUR: 3.6 },
                    NL: { EUR: 3.6 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_246',
            Typ: 'auftrommelnRatePerMeter',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 5.6 },
                    AT: { EUR: 5.6 },
                    BE: { EUR: 5.6 },
                    FR: { EUR: 4.48 },
                    NL: { EUR: 5.6 },
                },
            },
            Id: 2250532986,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 5.6 },
                    DE: { EUR: 5.6 },
                    AT: { EUR: 5.6 },
                    BE: { EUR: 5.6 },
                    FR: { EUR: 5.6 },
                    NL: { EUR: 5.6 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_247',
            Typ: 'verpackungTrommelGreater1500',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 90 },
                    AT: { EUR: 90 },
                    BE: { EUR: 90 },
                    FR: { EUR: 72 },
                    NL: { EUR: 90 },
                },
            },
            Id: 2454570228,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 90 },
                    DE: { EUR: 90 },
                    AT: { EUR: 90 },
                    BE: { EUR: 90 },
                    FR: { EUR: 90 },
                    NL: { EUR: 90 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_248',
            Typ: 'befestigungZugentlastungFactor',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 1.47 },
                    AT: { EUR: 1.47 },
                    BE: { EUR: 1.47 },
                    FR: { EUR: 1.176 },
                    NL: { EUR: 1.47 },
                },
            },
            Id: 2642016239,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 1.47 },
                    DE: { EUR: 1.47 },
                    AT: { EUR: 1.47 },
                    BE: { EUR: 1.47 },
                    FR: { EUR: 1.47 },
                    NL: { EUR: 1.47 },
                },
            },
            CalculatedPriceVK: {
                count: 5,
                unitPrice: {
                    Countries: {
                        EE: { EUR: 1.47 },
                        DE: { EUR: 1.47 },
                        AT: { EUR: 1.47 },
                        BE: { EUR: 1.47 },
                        FR: { EUR: 1.47 },
                        NL: { EUR: 1.47 },
                    },
                },
                totalPrice: {
                    Countries: {
                        EE: { EUR: 7.35 },
                        DE: { EUR: 7.35 },
                        AT: { EUR: 7.35 },
                        BE: { EUR: 7.35 },
                        FR: { EUR: 7.35 },
                        NL: { EUR: 7.35 },
                    },
                },
            },
            CalculatedPriceEK: {
                count: 5,
                unitPrice: {
                    Countries: {
                        EE: { EUR: 1.47 },
                        AT: { EUR: 1.47 },
                        BE: { EUR: 1.47 },
                        FR: { EUR: 1.176 },
                        NL: { EUR: 1.47 },
                    },
                },
                totalPrice: {
                    Countries: {
                        EE: { EUR: 7.35 },
                        AT: { EUR: 7.35 },
                        BE: { EUR: 7.35 },
                        FR: { EUR: 5.88 },
                        NL: { EUR: 7.35 },
                    },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_249',
            Typ: 'verpackungTrommelUnder1501',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 54 },
                    AT: { EUR: 54 },
                    BE: { EUR: 54 },
                    FR: { EUR: 43.2 },
                    NL: { EUR: 54 },
                },
            },
            Id: 2753576800,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 54 },
                    DE: { EUR: 54 },
                    AT: { EUR: 54 },
                    BE: { EUR: 54 },
                    FR: { EUR: 54 },
                    NL: { EUR: 54 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_250',
            Typ: 'BeschriftungLeitungFactorLessThan_4',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 8.5 },
                    AT: { EUR: 8.5 },
                    BE: { EUR: 8.5 },
                    FR: { EUR: 6.8 },
                    NL: { EUR: 8.5 },
                },
            },
            Id: 2930247290,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 8.5 },
                    DE: { EUR: 8.5 },
                    AT: { EUR: 8.5 },
                    BE: { EUR: 8.5 },
                    FR: { EUR: 8.5 },
                    NL: { EUR: 8.5 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_251',
            Typ: 'schliessenOeffnungsstegFactorKette',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 0.19 },
                    AT: { EUR: 0.19 },
                    BE: { EUR: 0.19 },
                    FR: { EUR: 0.152 },
                    NL: { EUR: 0.19 },
                },
            },
            Id: 2936797890,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 0.19 },
                    DE: { EUR: 0.19 },
                    AT: { EUR: 0.19 },
                    BE: { EUR: 0.19 },
                    FR: { EUR: 0.19 },
                    NL: { EUR: 0.19 },
                },
            },
            CalculatedPriceVK: {
                count: 30,
                unitPrice: {
                    Countries: {
                        EE: { EUR: 0.19 },
                        DE: { EUR: 0.19 },
                        AT: { EUR: 0.19 },
                        BE: { EUR: 0.19 },
                        FR: { EUR: 0.19 },
                        NL: { EUR: 0.19 },
                    },
                },
                totalPrice: {
                    Countries: {
                        EE: { EUR: 5.7 },
                        DE: { EUR: 5.7 },
                        AT: { EUR: 5.7 },
                        BE: { EUR: 5.7 },
                        FR: { EUR: 5.7 },
                        NL: { EUR: 5.7 },
                    },
                },
            },
            CalculatedPriceEK: {
                count: 30,
                unitPrice: {
                    Countries: {
                        EE: { EUR: 0.19 },
                        AT: { EUR: 0.19 },
                        BE: { EUR: 0.19 },
                        FR: { EUR: 0.152 },
                        NL: { EUR: 0.19 },
                    },
                },
                totalPrice: {
                    Countries: {
                        EE: { EUR: 5.7 },
                        AT: { EUR: 5.7 },
                        BE: { EUR: 5.7 },
                        FR: { EUR: 4.56 },
                        NL: { EUR: 5.7 },
                    },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_252',
            Typ: 'leitungEinlegenMeterFactorChainWithFachboeden',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 2.337 },
                    AT: { EUR: 2.337 },
                    BE: { EUR: 2.337 },
                    FR: { EUR: 1.8696 },
                    NL: { EUR: 2.337 },
                },
            },
            Id: 3571408498,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 2.337 },
                    DE: { EUR: 2.337 },
                    AT: { EUR: 2.337 },
                    BE: { EUR: 2.337 },
                    FR: { EUR: 2.337 },
                    NL: { EUR: 2.337 },
                },
            },
            CalculatedPriceVK: {
                count: 5,
                totalPrice: {
                    Countries: {
                        EE: { EUR: 25.555095 },
                        DE: { EUR: 25.555095 },
                        AT: { EUR: 25.555095 },
                        BE: { EUR: 25.555095 },
                        FR: { EUR: 25.555095 },
                        NL: { EUR: 25.555095 },
                    },
                },
            },
            CalculatedPriceEK: {
                count: 5,
                totalPrice: {
                    Countries: {
                        EE: { EUR: 25.555095 },
                        AT: { EUR: 25.555095 },
                        BE: { EUR: 25.555095 },
                        FR: { EUR: 20.444076000000003 },
                        NL: { EUR: 25.555095 },
                    },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_253',
            Typ: 'verpackungMaterialTrommel',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 10 },
                    AT: { EUR: 10 },
                    BE: { EUR: 10 },
                    FR: { EUR: 8 },
                    NL: { EUR: 10 },
                },
            },
            Id: 3925421902,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 10 },
                    DE: { EUR: 10 },
                    AT: { EUR: 10 },
                    BE: { EUR: 10 },
                    FR: { EUR: 10 },
                    NL: { EUR: 10 },
                },
            },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: '1514974577007_254',
            Typ: 'leitungEinlegenMeterFactorChainWithTrennstegen',
            BasePriceEK: {
                Countries: {
                    EE: { EUR: 1.52 },
                    AT: { EUR: 1.52 },
                    BE: { EUR: 1.52 },
                    FR: { EUR: 1.216 },
                    NL: { EUR: 1.52 },
                },
            },
            Id: 4284032790,
            BasePriceVK: {
                Countries: {
                    EE: { EUR: 1.52 },
                    DE: { EUR: 1.52 },
                    AT: { EUR: 1.52 },
                    BE: { EUR: 1.52 },
                    FR: { EUR: 1.52 },
                    NL: { EUR: 1.52 },
                },
            },
        },
    ],
    Fuehrungsrinnen: [
        {
            ArticleType: echain_product_models_1.ArticleType.fuehrungsrinne,
            EntityId: '1514974577007_255',
            Id: 39092,
            ArtNr: { DE: '970.30.SL', US: '970-30-SL' },
            ArtNrExists: true,
            BestTyp: 100,
            Bezeichnung: {
                GBen: '1 set with 2 trough side parts, 2 m each, including glide strips, without glide bars',
                DEde: '1 Set mit 2 Rinnenseitenteilen je 2 m, inkl. Gleitleisten, ohne Gleitschienen',
                PTpt: '1 conjunto de 2 m de guia lateral, incluindo faixas deslizantes sem barra deslizante',
                ESes: '1 juego con 2 partes laterales de carril, incl. bandas de deslizamiento, sin barras deslizantes, pieza de 2 m',
                FRfr: '1 jeu comprenant 2 parties latérales de goulotte de 2 m chacune, bandes latérales inclues, sans bandes de glissement',
                JPja: 'サイドパーツ2枚(各2m単位)、スライドパット付、スライドレール「なし」の一式',
                SEsv: '1 sats med 2 rännsidodelar à 2 m, inkl. glidlister, utan glidskenor',
                CZcs: '1 sada 2 žlabových bočních dílů, každý 2 m, vč. kluzných pásů, bez kluzné tyče',
                DKda: '1 sæt med 2 rendesidedele, hver på 2 m, inkl. glidebånd, uden glideskinne',
                ITit: '1 serie di 2 canali laterali passanti ogni 2 m, incl. profili di scorrimento, senza barra di scorrimento',
                KRko: '2 m 길이의 쓰루 사이드 부품 2 개가 1 세트, 글라이드 스트립 포함, 글라이드 바 불포함',
                HUhu: '1 készlet 2 db, egyenként 2 m-es vályú oldalelemből, csúszósávokkal, csúszóléc nélkül',
                USen: '1 set of 2 trough side parts each 2 m, incl. glide strips, without glide bar',
                CNzh: '1套有2个导向槽侧板，每根长2米，包括导向条，不带耐磨滑条',
                PLpl: '1 zestaw dwóch koryt bocznych, każde długości 2m, w tym pasy ślizgowe, bez drążka ślizgowego',
                TWzh: '1套有2個導向槽側板，每根長2米，包括導向條，不帶耐磨滑條',
                NLnl: '1 set van 2 gootzijdelen van elk 2 m, incl. glijstrips, zonder glijbalk',
            },
            Gewicht: { Value: 2.1, Unit: 'kg' },
            ZusBreiteFRBefestigungInnen: [],
            ZusBreiteFRBefestigungAussen: [],
            BefestigungInnenCProfil: [],
        },
        {
            ArticleType: echain_product_models_1.ArticleType.fuehrungsrinne,
            EntityId: '1514974577007_256',
            Id: 39093,
            ArtNr: { DE: '970.30.SL', US: '970-30-SL' },
            ArtNrExists: true,
            BestTyp: 100,
            Bezeichnung: {
                GBen: '1 set with 2 trough side parts, 2 m each, including glide strips, without glide bars',
                DEde: '1 Set mit 2 Rinnenseitenteilen je 2 m, inkl. Gleitleisten, ohne Gleitschienen',
                PTpt: '1 conjunto de 2 m de guia lateral, incluindo faixas deslizantes sem barra deslizante',
                ESes: '1 juego con 2 partes laterales de carril, incl. bandas de deslizamiento, sin barras deslizantes, pieza de 2 m',
                FRfr: '1 jeu comprenant 2 parties latérales de goulotte de 2 m chacune, bandes latérales inclues, sans bandes de glissement',
                JPja: 'サイドパーツ2枚(各2m単位)、スライドパット付、スライドレール「なし」の一式',
                SEsv: '1 sats med 2 rännsidodelar à 2 m, inkl. glidlister, utan glidskenor',
                CZcs: '1 sada 2 žlabových bočních dílů, každý 2 m, vč. kluzných pásů, bez kluzné tyče',
                DKda: '1 sæt med 2 rendesidedele, hver på 2 m, inkl. glidebånd, uden glideskinne',
                ITit: '1 serie di 2 canali laterali passanti ogni 2 m, incl. profili di scorrimento, senza barra di scorrimento',
                KRko: '2 m 길이의 쓰루 사이드 부품 2 개가 1 세트, 글라이드 스트립 포함, 글라이드 바 불포함',
                HUhu: '1 készlet 2 db, egyenként 2 m-es vályú oldalelemből, csúszósávokkal, csúszóléc nélkül',
                USen: '1 set of 2 trough side parts each 2 m, incl. glide strips, without glide bar',
                CNzh: '1套有2个导向槽侧板，每根长2米，包括导向条，不带耐磨滑条',
                PLpl: '1 zestaw dwóch koryt bocznych, każde długości 2m, w tym pasy ślizgowe, bez drążka ślizgowego',
                TWzh: '1套有2個導向槽側板，每根長2米，包括導向條，不帶耐磨滑條',
                NLnl: '1 set van 2 gootzijdelen van elk 2 m, incl. glijstrips, zonder glijbalk',
            },
            Gewicht: { Value: 2.1, Unit: 'kg' },
            ZusBreiteFRBefestigungInnen: [],
            ZusBreiteFRBefestigungAussen: [],
            BefestigungInnenCProfil: [],
        },
    ],
    MontageSets: [
        {
            ArticleType: echain_product_models_1.ArticleType.montageSet,
            EntityId: '1514974577007_257',
            Id: 2532,
            ArtNr: { DE: '960.30.125', US: '960-30-125' },
            ArtNrExists: true,
            BestTyp: 100,
            Bezeichnung: {
                DEde: 'Montageset, Befestigung innen mit C-Profil',
                GBen: 'Installation set, inside mounting with C-profile',
                ITit: 'Kit di montaggio, fissaggio interno con profilo a C',
                FRfr: 'Kit de montage, fixation intérieure avec rail en C',
                PTpt: 'Conjunto de instalação, montagem no perfil C',
                ESes: 'Juego de montaje, fijación interior con perfil C',
                JPja: '組立セット、C型レール付、内側取付',
                PLpl: 'Zestaw instalacyjny, mocowany do wewnątrz z profilem C',
                CNzh: '安装套件，内带可装配的C型槽',
                SEsv: 'Monteringssats, fastsättning i innerradien med C-profil',
                HUhu: 'Beépítési készlet, szerelés belül C-szelvénnyel',
                DKda: 'Installationssæt, indadvendt samling med C-profil',
                KRko: '설치 세트, C-프로파일 포함으로 내부에서 조립',
                CZcs: 'Instalační sada, montáž dovnitř s C profilem',
                USen: 'Installation set, fasten inside with C-profile',
                TWzh: '安裝套件，內帶可裝配的C型槽',
                NLnl: 'Installatieset, montage inwaarts met C-profiel',
            },
            Gewicht: { Value: 0.1725, Unit: 'kg' },
        },
        {
            ArticleType: echain_product_models_1.ArticleType.montageSet,
            EntityId: '1514974577007_258',
            Id: 2533,
            ArtNr: { DE: '960.30.125', US: '960-30-125' },
            ArtNrExists: true,
            BestTyp: 100,
            Bezeichnung: {
                DEde: 'Montageset, Befestigung innen mit C-Profil',
                GBen: 'Installation set, inside mounting with C-profile',
                ITit: 'Kit di montaggio, fissaggio interno con profilo a C',
                FRfr: 'Kit de montage, fixation intérieure avec rail en C',
                PTpt: 'Conjunto de instalação, montagem no perfil C',
                ESes: 'Juego de montaje, fijación interior con perfil C',
                JPja: '組立セット、C型レール付、内側取付',
                PLpl: 'Zestaw instalacyjny, mocowany do wewnątrz z profilem C',
                CNzh: '安装套件，内带可装配的C型槽',
                SEsv: 'Monteringssats, fastsättning i innerradien med C-profil',
                HUhu: 'Beépítési készlet, szerelés belül C-szelvénnyel',
                DKda: 'Installationssæt, indadvendt samling med C-profil',
                KRko: '설치 세트, C-프로파일 포함으로 내부에서 조립',
                CZcs: 'Instalační sada, montáž dovnitř s C profilem',
                USen: 'Installation set, fasten inside with C-profile',
                TWzh: '安裝套件，內帶可裝配的C型槽',
                NLnl: 'Installatieset, montage inwaarts met C-profiel',
            },
            Gewicht: { Value: 0.1725, Unit: 'kg' },
        },
    ],
    MontBes: [
        {
            ArticleType: echain_product_models_1.ArticleType.montBes,
            EntityId: '1564493246057_2407',
            ArtNrGenerated: 'BES0010006',
            ArtNrExists: false,
        },
        {
            ArticleType: echain_product_models_1.ArticleType.montBes,
            EntityId: '1564499638125_1601',
            ArtNrGenerated: 'MONT0010021.500.400',
            ArtNrExists: false,
        },
    ],
    PdfRefs: [],
    FileRefs: [],
    QuoteCount: 1,
    AllowedBauformen: ['Kette', 'Rohr'],
    AllowedKetteOpeningPrinciples: [
        echain_shared_articles_1.KetteOpeningPrinciple.InnerRadius,
        echain_shared_articles_1.KetteOpeningPrinciple.OuterRadius,
        echain_shared_articles_1.KetteOpeningPrinciple.InnerAndOuterRadius,
        echain_shared_articles_1.KetteOpeningPrinciple.Closed,
    ],
    AverageEnvironmentTemperatur: { Unit: '°C', Value: 20 },
    IsStackingOfLeitungenAllowed: true,
    HasNoRinne: false,
    LeitungBomBehavior: echain_shared_articles_oo_1.LeitungBomBehavior.UseAll,
    UseSameIAColorAndMaterial: false,
};
//# sourceMappingURL=configurationJson.mock.js.map